import { FC, useEffect, useMemo } from 'react'

import { SiteInspectionResponseHeader } from './SiteInspectionResponseHeader'
import { SiteInspectionResponseForm } from './SiteInspectionResponseForm'
import { DLMSiteApplication } from '../../../core/doclabel'

type Props = {
    site: DLMSiteApplication
    workflow: string
    doClose: Function
}

const SiteInspectionResponseModal: FC<Props> = ({site, workflow, doClose}) => {

    const { siteState, siteID, appID, siteROIS, modalWidth } = useMemo(() => {
        if (! site) return { siteState : '', siteID : 0, appID: 0, siteROIS: [], modalWidth: 500};
        const { state: siteState, id: siteID, dlmApplication, rois: siteROIS } = site;
        const { id: appID  } = dlmApplication;
        const modalWidth = siteState === 'Site Labelling' ? 700 : 500

        return { siteState, siteID, appID, siteROIS, modalWidth } 
    }, [site]);

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    return (
    <>
    <div
        className='modal fade show d-block'
        id='kt_site_inspection_response_modal'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
    >    
        <div className={`modal-dialog modal-dialog-centered mw-${modalWidth}px`}>    
            <div className='modal-content'>
                <SiteInspectionResponseHeader siteState={siteState} doClose={doClose} />                
                <div className='modal-body p-4'>
                    <SiteInspectionResponseForm 
                        siteID={siteID} 
                        siteState={siteState} 
                        siteROIS={siteROIS}
                        appID={appID ? appID : 0}
                        workflow={workflow}
                        doClose={doClose}                     
                    />
                </div>                
            </div>            
        </div>            
    </div>    
    <div className='modal-backdrop fade show'></div>    
    </>
    )
}

export {SiteInspectionResponseModal}
